import { createEffect, on, onCleanup, onMount } from 'solid-js'
import removeItem from '../array/remove_item'

export enum EventResult {
  /**
   * Continue processing the event.
   */
  Continue = 0,

  /**
   * Stop processing the event.
   */
  Stop = 1,
}

/**
 * EventListener<T> - A function that takes an event value of type T and returns void or EventResult.
 *
 * If the event listener returns EventResult.Stop,
 * the event emission will stop processing any more listeners immediately.
 * This is useful for implementing event cancellation.
 */
export type EventListener<T> = (event: T) => void | EventResult

export type EventListenerList<T> = Array<EventListener<T>>

// interface MightHavePriorityNumber {
//   priority?: number
// }

// function sortByPriorityDesc<T>(a: EventListener<T>, b: EventListener<T>) {
//   return ((b as MightHavePriorityNumber).priority ?? 0) - ((a as MightHavePriorityNumber).priority ?? 0)
// }

export function addListener<T>(list: EventListenerList<T>, fn: EventListener<T>): void {
  list.push(fn)
}

export function removeListener<T>(list: EventListenerList<T>, fn: EventListener<T>): void {
  removeItem(list, fn)
}

export function flushListeners<T>(list: EventListenerList<T>): void {
  list.length = 0
}

export function emitEvent<T>(list: EventListenerList<T>, data: T): void | EventResult {
  // list.sort(sortByPriorityDesc)
  // const len = list.length
  // for (let index = 0; index < len; index++) {
  //   if (list[index](data) === false) {
  //     return
  //   }
  // }
  // console.log('emitEvent', list, data)
  let index = list.length
  while (index-- > 0) {
    const result = list[index](data)
    if (result === EventResult.Stop) {
      // console.log('emitEvent returned EventResult.Stop, processing no more listeners')
      return result
    }
  }
  // console.log('emitEvent ran all listeners')
}

export function emitEventNextTick<T>(list: EventListenerList<T>, data: T): void {
  // console.log('emitNextTick', data)
  setTimeout(emitEvent, 1, list, data)
}

// addListener(engine.el[Event.CoolStuff])

export function mountListener<T>(list: EventListenerList<T>, fn: EventListener<T>): void {
  onMount(() => addListener(list, fn))
  onCleanup(() => removeListener(list, fn))
}

export function mountListenerWhen<T>(
  list: EventListenerList<T>,
  when: () => unknown,
  fn: EventListener<T>
): void {

  onMount(() => {
    createEffect(on(when, (value) => {
      removeListener(list, fn)
      if (value) {
        addListener(list, fn)
      }
      // console.log(value ? 'addListener' : 'removeListener')
    }))
    onCleanup(() => removeListener(list, fn))
  })
}
